<template>
  <div class="page">
    <nut-navbar style="position: fixed;z-index: 100;left: 0;right: 0;height: 57px;line-height: 57px;text-align: center;background: var(--nut-white, #fff);
        font-weight: 700;
        font-size: 1.5rem;
        color: #333;
        -webkit-box-shadow: 0px 4px 10px 0px rgb(0 0 0 / 7%);
        box-shadow: 0 4px 10px rgb(0 0 0 / 7%);"
        @on-click-back="goBack" 
        :leftShow="true" 
        :rightShow="false"
      >{{ $t('cardPayEnd.title') }}</nut-navbar>
    <div class="containerClass">
      <img v-if="mobileType == 1" src="../../assets/img/successFail.png" class="telecom-logo"/> 
      <img v-if="mobileType == 2" src="../../assets/img/successPay.png" class="telecom-logo"/> 
      <div class="divClass">
        <nut-button shape="circle"  @click="returnButton()">{{$t('cardPayEnd.Details')}}</nut-button>
      </div>
    </div>
  </div>
</template>
<script>
import { wx_paypalSuccess } from "@/api/api.js"; 
export default {
  data() {
    return {
      mobileType:2,
      propsParams:{},
      iccid:""
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    initData(){
      this.propsParams = this.getQueryString(window.location.href);
      let params ={
        ...this.propsParams
      }
      wx_paypalSuccess(params).then(res =>{
        if(res.data.code == 200){
          this.mobileType = 2;
          this.iccid = res.data.data.iccid;
        }else{
          this.mobileType = 1
          this.iccid = res.data.data.iccid;
        }
      })
    },
    returnButton(){
      this.$router.push({
        path: "/international/cardInfo",
        query: {
          iccid: this.iccid,
        }
      })
    },
    // 获取url的参数
    getQueryString(url){    
      var theRequest = new Object();   
      if (url.indexOf("?") != -1) {   
        var str = url.substr(url.indexOf("?") + 1);  
        var strs = str.split("&");   
        for(var i = 0; i < strs.length; i ++) {   
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);   
        }   
      }   
      return theRequest;     
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  created() {
    this.$i18n.locale = this.language;
    this.initData()
  },
  mounted() {

  },
};
</script>
<style scoped lang="less">
  .page{
    font-size: 14px;
    font-family: Avenir, Helvetica, Arial, sans-serif, 'Microsoft YaHei','PingFangSC-Regular','Roboto';
    background: #fff;
    height: 100%;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    /deep/ .nut-title{
      font-weight: 700;
    }
    .containerClass{
      font-size: 1rem;
      overflow-y: auto;
      padding: 66px;
      color: #6e6e6e;
      width: 100%;
      text-align: center;
    }
    .telecom-logo{
      width: 130px;
      height: 130px;
    }
    .divClass{
      font-size:1.1rem;
      margin-top: 20px;
    }
    /deep/ .nut-button{
      font-size: 1.1rem;
      background:#0186D3
    }

  }
</style>

